/**
 * PERSON PHONE API — CRUD dei phone di un Person.
 *
 * Contratto backend (rest-openapi.yaml, PeopleResourceImpl):
 *   POST   /person/{personId}/phone                PhoneInput -> Phone
 *   PATCH  /person/{personId}/phone/{phoneId}      PhoneInput -> Phone
 *   DELETE /person/{personId}/phone/{phoneId}                  -> 200
 *
 * Stesso pattern per-owner di personEmailAddressApi. Lo speculare
 * Business vive in business/businessPhoneApi.ts (Step 2).
 */

import { httpClient } from '../../api/httpClient';
import type { Phone } from '../phone/phoneTypes';

interface PhoneInput {
  number: string;
  primary: boolean;
  listTypeId?: number;
}

const NESTED = (personId: number) => `/person/${personId}/phone`;

export const personPhoneApi = {
  create: (personId: number, payload: PhoneInput): Promise<Phone> =>
    httpClient.post<Phone>(NESTED(personId), payload).then((r) => r.data),

  update: (
    personId: number,
    phoneId: number,
    payload: PhoneInput
  ): Promise<Phone> =>
    httpClient
      .patch<Phone>(`${NESTED(personId)}/${phoneId}`, payload)
      .then((r) => r.data),

  remove: (personId: number, phoneId: number): Promise<void> =>
    httpClient.delete(`${NESTED(personId)}/${phoneId}`).then(() => undefined),
};
